<template>
    <vue-slider v-bind="options" :min="min" :max="max" :interval="interval" :value="value" @callback="update" @drag-start="dragStart" @drag-end="dragEnd"></vue-slider>
</template>

<script>
import vueSlider from 'vue-slider-component';

export default {
    components: {
        vueSlider
    },
    props: {
        min: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        },
        interval: {
            type: Number,
            default: 1
        },
        value: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            options: {
                height: 4,
                speed: 0.1,
                tooltip: false,
                'process-style': { 'background-color': '#000' },
                'slider-style': {
                    'box-shadow': '0.5px 0.5px 4px 2px rgba(0,0,0,.32)'
                }
            },
            dragging: false
        };
    },
    methods: {
        update(value) {
            this.$emit('input', value);
            if (!this.dragging) {
                this.dragEnd(value);
            }
        },
        dragStart() {
            this.dragging = true;
        },
        dragEnd(value) {
            this.dragging = false;
            this.$emit('drag-end', value);
        }
    }
};
</script>
